<div class="parent-wrapper" [matTooltip]="'speedReading.quiz.result.question' | translate">
  <div class="question question-1">?</div>
  <div class="question question-2">?</div>
  <div class="question question-3">?</div>
  <div class="wrapper">
    <div class="value">{{ value }}</div>
    <div *ngIf="from !== null" class="from">{{ 'speedReading.quiz.result.from' | translate }} {{ from }}</div>
  </div>
</div>
